var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUptime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92075 14.3545C7.14126 14.3545 7.32002 14.1758 7.32002 13.9553C7.32002 13.7347 7.14126 13.556 6.92075 13.556C6.70024 13.556 6.52148 13.7347 6.52148 13.9553C6.52148 14.1758 6.70024 14.3545 6.92075 14.3545Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43638 14.3545C8.65689 14.3545 8.83565 14.1758 8.83565 13.9553C8.83565 13.7347 8.65689 13.556 8.43638 13.556C8.21587 13.556 8.03711 13.7347 8.03711 13.9553C8.03711 14.1758 8.21587 14.3545 8.43638 14.3545Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.952 14.3545C10.1725 14.3545 10.3513 14.1758 10.3513 13.9553C10.3513 13.7347 10.1725 13.556 9.952 13.556C9.73149 13.556 9.55273 13.7347 9.55273 13.9553C9.55273 14.1758 9.73149 14.3545 9.952 14.3545Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 12.7764H31.0593V8.37125H23.7188V12.7764Z",
    fill: "#DEDEDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6125 8.13772C33.6125 8.56957 33.2609 8.92019 32.8284 8.92019H21.8217C21.3898 8.92019 21.0391 8.56957 21.0391 8.13772V3.45915C21.0391 3.02662 21.3898 2.67668 21.8217 2.67668H32.8284C33.2609 2.67668 33.6125 3.02662 33.6125 3.45915V8.13772Z",
    fill: "#50725F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8398 16.8627L46.0825 20.4139L47.9585 18.1731L43.7145 14.6222L41.8398 16.8627Z",
    fill: "#BDBCBC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8154 18.6855C48.6323 18.9058 48.3199 18.9491 48.1203 18.782L43.0318 14.5234C42.8322 14.3552 42.819 14.0418 43.0027 13.8218L44.9941 11.4422C45.1782 11.2229 45.4899 11.1789 45.6892 11.3471L50.7783 15.606C50.9784 15.7729 50.9912 16.0863 50.8071 16.3073L48.8154 18.6855Z",
    fill: "#918F90"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4276 16.8627L8.18466 20.4139L6.30859 18.1731L10.5524 14.6222L12.4276 16.8627Z",
    fill: "#DEDEDE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45142 18.6855C5.63547 18.9058 5.94693 18.9491 6.14685 18.782L11.2349 14.5234C11.4352 14.3552 11.4482 14.0418 11.2639 13.8218L9.2729 11.4422C9.08889 11.2229 8.77709 11.1789 8.57839 11.3471L3.48939 15.606C3.28884 15.7729 3.27604 16.0863 3.46005 16.3073L5.45142 18.6855Z",
    fill: "#50725F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M53.649 37.7758C53.649 52.3131 41.8632 64.0992 27.3253 64.0992C12.7862 64.0992 1 52.3131 1 37.7758C1 23.2358 12.7862 11.4517 27.3253 11.4517C41.8632 11.4517 53.649 23.2358 53.649 37.7758Z",
    fill: "url(#paint0_linear_8356_16411)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3257 59.7469C15.191 59.7469 5.35352 49.9091 5.35352 37.7758C5.35352 25.6401 15.191 15.8044 27.3257 15.8044C39.4594 15.8044 49.2968 25.6401 49.2968 37.7758C49.2968 49.9091 39.4594 59.7469 27.3257 59.7469Z",
    fill: "#0E2335"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.258 37.7758C48.258 49.3368 38.8863 58.7072 27.3259 58.7072C15.7648 58.7072 6.39258 49.3368 6.39258 37.7758C6.39258 26.214 15.7648 16.8434 27.3259 16.8434C38.8863 16.8434 48.258 26.214 48.258 37.7758Z",
    fill: "#EEF6FC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5068 36.4995C28.5068 37.2031 27.9781 37.7758 27.3273 37.7758C26.6748 37.7758 26.1465 37.2031 26.1465 36.4995V22.1369C26.1465 21.4316 26.6748 20.86 27.3273 20.86C27.9781 20.86 28.5068 21.4316 28.5068 22.1369V36.4995Z",
    fill: "#0A1B29"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1504 39.2751C26.7842 38.9072 26.8628 38.235 27.3261 37.7758C27.7891 37.3155 28.4599 37.2434 28.8257 37.613L36.2889 45.1388C36.6555 45.5081 36.577 46.1802 36.1136 46.6391C35.6503 47.0984 34.9785 47.1708 34.6123 46.8013L27.1504 39.2751Z",
    fill: "#0A1B29"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5808 37.7758C29.5808 39.0199 28.5716 40.0305 27.3262 40.0305C26.08 40.0305 25.0703 39.0199 25.0703 37.7758C25.0703 36.5293 26.08 35.5204 27.3262 35.5204C28.5716 35.5204 29.5808 36.5293 29.5808 37.7758Z",
    fill: "#0A1B29"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7333 37.7758C28.7333 38.5539 28.1014 39.1844 27.324 39.1844C26.5452 39.1844 25.9141 38.5539 25.9141 37.7758C25.9141 36.9967 26.5452 36.3655 27.324 36.3655C28.1014 36.3655 28.7333 36.9967 28.7333 37.7758Z",
    fill: "#183A59"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.159 37.637L18.0684 48.0677L18.3872 48.3452L27.4778 37.9149",
    fill: "#183A59"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1113 18.8828H27.534V17.5175H27.1113V18.8828Z",
    fill: "#0A1B29"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1113 58.2117H27.534V56.8468H27.1113V58.2117Z",
    fill: "#0A1B29"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3066 38.076H47.6729V37.6533H46.3066V38.076Z",
    fill: "#0A1B29"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97461 38.076H8.33971V37.6533H6.97461V38.076Z",
    fill: "#0A1B29"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5636 23.3272L40.5977 24.2941L40.8968 24.5929L41.8627 23.626",
    fill: "#0A1B29"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7529 51.136L12.7871 52.1015L13.0861 52.4007L14.0519 51.4352",
    fill: "#0A1B29"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8624 52.1015L40.8968 51.136L40.5977 51.4352L41.5636 52.4007",
    fill: "#0A1B29"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.052 24.2941L13.0863 23.3272L12.7871 23.626L13.7528 24.5929",
    fill: "#0A1B29"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7168 35.8807V15.0456C44.7168 14.8426 44.8822 14.678 45.0861 14.678H54.0774C54.2813 14.678 54.4467 14.8426 54.4467 15.0456V35.8807C54.4467 36.0836 54.2813 36.2482 54.0774 36.2482H45.0861C44.8822 36.2482 44.7168 36.0836 44.7168 35.8807Z",
    fill: "url(#paint1_linear_8356_16411)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1104 14.7837L49.3217 2.62902C49.4659 2.4854 49.6999 2.4854 49.844 2.62902L49.8462 2.63116L62.0575 14.7858V14.7857C62.2017 14.9293 62.2017 15.162 62.0575 15.3056C61.9855 15.3773 61.8909 15.4133 61.7964 15.4133H37.3693C37.1654 15.4133 37 15.2486 37 15.0456C37 14.9431 37.0423 14.8503 37.1103 14.7837H37.1104Z",
    fill: "#2AC8BE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8356_16411",
    x1: 27.3245,
    y1: 64.0992,
    x2: 27.3245,
    y2: 11.4517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AADDC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C8D73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8356_16411",
    x1: 49.6513,
    y1: 26.9255,
    x2: 49.5817,
    y2: 14.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AC8BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptime);
export default __webpack_public_path__ + "static/media/uptime.105c6b74898a421e15f88dbc193bfa21.svg";
export { ForwardRef as ReactComponent };